import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  create(organizationId, data) {
    return HTTP.post(`/api/v1/organizations/${organizationId}/checklists`, data)
  },

  update(organizationId, checklistId, data) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}`,
      data
    )
  },

  getById(organizationId, checklistId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}`
    )
  },

  get(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }
    const url = `/api/v1/organizations/${organizationId}/checklists`
    return HTTP.get(url, params)
  },

  createResponse(organizationId, checklistId, data) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses`,
      data
    )
  },

  getResponsesByChecklistId(organizationId, checklistId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses`
    return HTTP.get(url, params)
  },

  updateResponse(organizationId, checklistId, responseId, data) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses/${responseId}`,
      data
    )
  },

  getResponseById(organizationId, checklistId, responseId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/checklists/${checklistId}/responses/${responseId}`
    )
  },

  getChecklistInsights(organizationId, checklistId, options) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/insights/checklists/${checklistId}`
    return HTTP.get(url, params)
  },
}
